import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PDFViewer } from "@react-pdf/renderer";
import moment from "moment-timezone";

import { useSnackbar } from "notistack";
import { TIME } from "../../utils/const";
import baseRequest from "../../core/baseRequest";
import useControl from "../../hooks/useControl";
import useSignOut from "../../hooks/useSignOut";
import { errorHandler } from "../../core/errorHandler";
import PreventativeReportDocument from "./preventativeReportDocument";

const PreventativeReportPage = (props) => {
  const [auth] = useControl();
  const [controller] = useSignOut();

  const [data, setData] = useState();

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const loadPMReportData = async (res) => {
    try {
      const res = await baseRequest.post("/report/monthly", { date: "" });
      if (auth(res)) {
        const data = res.data;

        if (window.state) {
          data.records.maintenancesLog = data.records.maintenancesLog.filter(
            ({ target }) => window.state.targets.includes(target)
          );
        }

        if (data.records.maintenancesLog.length === 0) {
          enqueueSnackbar("There is no data to show!", {
            variant: "error",
          });
        }
        setData(data);
      }
    } catch (error) {
      const { data, status } = errorHandler();
      switch (status) {
        case 401:
          controller.forceLogin();
          break;
        case 403:
          navigate("/noaccess");
          break;
        case 404:
          enqueueSnackbar("Something went wrong retrieving configurations!", {
            variant: "error",
          });
          break;
        case 500:
          enqueueSnackbar(
            "Something went wrong while authenticating the user!",
            {
              variant: "error",
            }
          );
          break;
        default:
          enqueueSnackbar(data, {
            variant: "error",
          });
          break;
      }
    }
  };

  useEffect(() => {
    document.title = props.title || "";
  }, [props.title]);

  useEffect(() => {
    loadPMReportData();
  }, []);

  useEffect(() => {
    //This is for reloading home page
    const interval = setInterval(() => {
      loadPMReportData();
    }, TIME);

    return () => clearInterval(interval);
  }, []);

  return data && data.records.maintenancesLog.length > 0 ? (
    <PDFViewer showToolbar={true} style={{ width: "100%", height: "1000px" }}>
      <PreventativeReportDocument data={data} />
    </PDFViewer>
  ) : null;
};

export default PreventativeReportPage;
